import type { OrderItem } from "web/types/Order";
import type { MBProductType } from "web/types/Product";

type ProductItem = Omit<OrderItem<MBProductType>, "product_data"> & {
  product_data: { entity_id: string };
};

interface IProductsInfo {
  productId: string;
  fullCategoryPath: string;
  fullAttributePath: string;
  fullCategoriesPaths: string[];
}

const getProductInfo = (
  productsInfo: IProductsInfo[],
  productItem: ProductItem
) => {
  const product =
    productsInfo?.find(
      (element) => element.productId === productItem.product_data?.entity_id
    ) || ({} as IProductsInfo);

  const {
    fullCategoryPath: productCategoryPath,
    fullAttributePath: productAttributesPath,
    fullCategoriesPaths,
  } = product;

  return {
    category: productCategoryPath,
    variant: productAttributesPath,
    fullCategoriesPaths,
  };
};

export default getProductInfo;
